module.exports = __webpack_public_path__ + "static/media/france.bcd389de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flag/france.svg
// module id = 428
// module chunks = 120